/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
const HeadingMark = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("small", Object.assign({}, props, { ref: ref, css: {
            color: theme.colors.heading.mark,
        } })));
});
HeadingMark.displayName = 'HeadingMark';
export default React.memo(HeadingMark);
//# sourceMappingURL=HeadingMark.js.map